import type { PeriodMaster } from '@dcc-erp/shared';

import { isDateInOpenPeriod } from '../journal/periodGuard';

// Returns a Thai gate reason when billDate is NOT in an OPEN period, else null.
// Reuses the journal create-modal's periodGuard so doc-ingest and manual entry
// share one open-period rule (§15.1).
export function acceptPeriodGate(periods: PeriodMaster[], billDateIso: string): string | null {
  if (isDateInOpenPeriod(periods, billDateIso)) return null;
  return 'งวดบัญชีปิดแล้ว — เลือกวันที่ในงวดที่เปิดอยู่ก่อนบันทึก';
}
